"use strict";

var $ = require("jquery");
import { navCategoriesSliderToSlide } from './_navCategoriesToSlide.js';

function navCategoriesClickNavItem() {

    const slider = $('.nav-slider');
    slider.on('click', '.menu-item-has-children > a', function (event) {
        event.preventDefault();
        navCategoriesSliderToSlide('next', event);
    });
}

$(document).ready(function () {
    navCategoriesClickNavItem();
});